import { IconButton, Stack } from '@mui/material'
import { ErrorIndicator } from 'components/Shared/ErrorIndicator'
import { colorPrimitives } from 'components/Theme'
import CloseIcon from '@mui/icons-material/Close'
import cx from 'classnames'

type SystemBannerVariant = 'Urgent' | 'Informational' | 'default'

const TextColorClassMap = {
  Urgent: colorPrimitives.white,
  Informational: colorPrimitives.redGaming,
  default: colorPrimitives.black,
}

const BackgroundColorClassMap = {
  Urgent: colorPrimitives.redGaming,
  Informational: colorPrimitives.white,
  default: colorPrimitives.black,
}

interface SystemBannerProps {
  message: string
  dismissable?: boolean
  type?: SystemBannerVariant
  filterBanners: () => void
}

export const SystemBanner = ({
  message,
  dismissable,
  type = 'default',
  filterBanners,
}: SystemBannerProps) => {
  const textStyles: string = TextColorClassMap[type]

  return (
    <Stack
      direction="row"
      bgcolor={BackgroundColorClassMap[type]}
      className="flex justify-between px-4 py-2 rounded-md w-4/6 shadow-md shadow-gray-500/75"
    >
      <ErrorIndicator
        style={cx('py-0 pt-0.5 leading-5 px-1.5')}
        color={textStyles}
        message={message}
      />

      {dismissable && (
        <IconButton onClick={() => filterBanners()} sx={{ padding: 0 }}>
          {type === 'Urgent' ? (
            <CloseIcon sx={{ color: '#ffffff' }} />
          ) : (
            <CloseIcon sx={{ color: colorPrimitives.redGaming }} />
          )}
        </IconButton>
      )}
    </Stack>
  )
}
